import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { OrderInBatch } from '@app/services/batches/print-batches';
import { OrderBatchService } from '@app/services/order-batch/order-batch.service';
import { FulfillService } from '@app/pages/workspace/fulfill/fulfill.service';
import { VoidModalComponent } from './components/void-modal/void-modal.component';
import { OrderBatch } from '@services/order-batch/order-batch.model';
@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'fulfill-back-to-assign-btn',
  templateUrl: './fulfill-back-to-assign-btn.component.html',
  styleUrls: ['./fulfill-back-to-assign-btn.component.scss'],
  standalone: false,
})
export class FulfillBackToAssignBtnComponent {
  @Input() batch: OrderBatch;
  @Input() batchStatus: 'running' | 'printing' | 'recentlyDone';
  @Input() order: OrderInBatch;
  @Input() disableBackToAssign;
  @Input() label;
  @Output() orderMoved = new EventEmitter<OrderInBatch>();
  loading = false;
  isOrder: boolean = false;
  orderIdForDialog: string = '';
  orderIdsForDialog: string[] = [];
  isCancel: boolean = false;

  constructor(
    private dialog: MatDialog,
    private orderBatchService: OrderBatchService,
    private fulfillService: FulfillService,
  ) {}

  backToAssign(): void {
    //check if carrier have cancel support
    if (this.order) {
      this.orderIdForDialog = this.order.orderNumber;
      this.isOrder = true;
      this.orderBatchService.checkBatchCarrierValid(this.batch.id).then((res) => {
        if (res) {
          this.isCancel = true;
          this.openOrderAndBatchAssignModal();
        } else {
          this.isCancel = false;
          this.openOrderAndBatchAssignModal();
        }
      });
    } else {
      //check for batch carrier support
      this.orderBatchService.checkBatchCarrierValid(this.batch.id).then((res) => {
        this.isOrder = false;
        this.batch.orders.map((order) => {
          if (this.orderIdsForDialog.indexOf(order.orderNumber) === -1) {
            this.orderIdsForDialog.push(order.orderNumber);
          }
        });
        if (res) {
          this.isCancel = true;
          this.openOrderAndBatchAssignModal();
        } else {
          this.isCancel = false;
          this.openOrderAndBatchAssignModal();
        }
      });
    }
  }

  openOrderAndBatchAssignModal(): void {
    const dialogRef = this.dialog.open(VoidModalComponent, {
      maxWidth: '100vw',
      width: '35vw',
      panelClass: 'overflow-visible-class',
      backdropClass: 'global_modal_overlay',
      disableClose: true,
      data: {
        scope: 'batch',
        batch: this.batch,
        orderId: this.order?.id,
        batchStatus: this.batchStatus,
      },
    });
    if (this.isOrder) {
      dialogRef.afterClosed().subscribe(() => {
        this.fulfillService.initLoadBatches();
        this.fulfillService.togglePanel(false);
        this.orderMoved.next(this.order);
      });
    } else {
      dialogRef.afterClosed().subscribe(() => {
        this.fulfillService.initLoadBatches();
        this.fulfillService.togglePanel(false);
      });
    }
  }
}
